import { useEffect, useState } from 'react';
import {
  fetchGames,
  type GameConfig,
} from '../lib/game-config';

type State =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ready'; game: GameConfig };

/**
 * SPA 按 URL 段解析已注册游戏（Go `/api/games`）。
 */
export function useRegisteredGame(gameParam: string): State {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    if (!gameParam) {
      setState({ status: 'error', message: '缺少游戏标识' });
      return;
    }
    let cancelled = false;
    setState({ status: 'loading' });
    const load = async () => {
      try {
        const list = await fetchGames();
        const matched =
          list.find((item) => item.domain === gameParam || item.key === gameParam) ||
          null;
        if (!matched) throw new Error('游戏不存在或已下线');
        if (matched.status === 'archived') throw new Error('游戏已归档');
        if (!cancelled) setState({ status: 'ready', game: matched });
      } catch (cause) {
        if (!cancelled) {
          setState({
            status: 'error',
            message: cause instanceof Error ? cause.message : '游戏加载失败',
          });
        }
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [gameParam]);

  return state;
}
